import '../styles/username.css'

function Username() {
    return (
        <div id="username_diplay">
            <div id='username'>
                <hr id='hr_username'/>
                <div id='username_element'>@hadock404</div>
            </div>
        </div>
    )
}

export default  Username